import { Menu, MenuButton, MenuItem, MenuList, Text } from '@tonic-one/react';
import { OverAllPolicyType } from '@Policy/utils/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PolicyTypeSelect = React.forwardRef((_, ref) => {
  const { t } = useTranslation();
  const [policyType, setPolicyType] = React.useState<OverAllPolicyType>(
    OverAllPolicyType.ATP
  );

  React.useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        return policyType;
      },
    };
  }, [policyType]);
  return (
    <Menu>
      <MenuButton variant="secondary">
        <Text>
          {policyType === OverAllPolicyType.ATP
            ? t('globalSetting.approvedUser.table.policyType.atp')
            : t('globalSetting.approvedUser.table.policyType.dlp')}
        </Text>
      </MenuButton>
      <MenuList
        width="max-content"
        onClick={(e: any) => {
          setPolicyType(e.target.getAttribute('value'));
        }}
      >
        <MenuItem value={OverAllPolicyType.ATP}>
          {t('globalSetting.approvedUser.table.policyType.atp')}
        </MenuItem>
        <MenuItem value={OverAllPolicyType.DLP}>
          {t('globalSetting.approvedUser.table.policyType.dlp')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
});

export default React.memo(PolicyTypeSelect);
